
<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="4" v-for="opt in options" :key="opt.flag">
        <div class="charge-option-card" :class="{ 'charge-option-card--active': payment.deposit_details[opt.flag] }">
          <v-checkbox
            v-model="payment.deposit_details[opt.flag]"
            :label="opt.label"
            color="blue darken-2"
            hide-details
            dense
            class="mt-1 mb-2"
          ></v-checkbox>
          <v-text-field
            v-if="payment.deposit_details[opt.flag]"
            v-model.lazy="payment.deposit_details[opt.value]"
            v-currency="currency"
            label="Valor"
            prefix="R$"
            prepend-inner-icon="mdi-currency-brl"
            :rules="[...required, ...not_zero, ...positive_number]"
            outlined
            dense
            hide-details="auto"
            class="mb-2"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>

    <v-row dense class="mt-2">
      <v-col cols="12" sm="4">
        <v-menu
          v-model="deposit_date"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :rules="required"
              :value="payment.deposit_details.deposit_date ? $moment(payment.deposit_details.deposit_date).format('L') : null"
              label="Data do depósito"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              hide-details="auto"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="payment.deposit_details.deposit_date"
            locale="pt-br"
            no-title
            @input="deposit_date = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          :items="company_banks"
          v-model="payment.deposit_details.deposit_bank"
          prepend-inner-icon="mdi-bank"
          :rules="[...required]"
          label="Banco"
          outlined
          dense
          hide-details="auto"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <SelectCompany
          @newCompany="handleNewCompany"
          :company="payment.deposit_details.deposit_company"
          outlined
          dense
        ></SelectCompany>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="payment.deposit_details.comment"
          prepend-inner-icon="mdi-comment-outline"
          label="Comentário"
          outlined
          dense
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'

export default {
  name: 'WithDeposit',
  mixins: [ validations ],
  directives: {
    currency: CurrencyDirective,
  },
  props: {
    with_doc: {
      type: Boolean,
      default: () => true,
    },
    payment: {
      type: Object,
    },
  },
  components: {
    SelectCompany: () => import("@/_backoffice/_registrations/components/shared/SelectCompany.vue"),
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      deposit_date: false,
      company_banks: ['Itaú','Sicoob','Caixa','Banco do Brasil'],
      options: [
        { flag: 'has_entrance', value: 'entrance_value_aux', label: 'À vista' },
        { flag: 'has_one_day', value: 'one_day_value_aux', label: '1 dia bloqueado' },
        { flag: 'has_two_days', value: 'two_days_value_aux', label: '2 dias bloqueado' },
      ],
    }
  },
  methods: {
    handleNewCompany(new_company){
      this.payment.deposit_details.deposit_company = new_company
    },
    handleDoneDoc(e) {
      this.$emit('doneDoc', e)
    },
    handleRemoveDoc(){
      this.$emit('removeDoc')
    },
  },
}
</script>

<style src="../../styles/charge_dialog.css"></style>
